module.exports = "/images/vendor/flag-icon-css/flags/4x3/ni.svg?7b131ab3ceaf55696b688d2617f21f54";